import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { AffiliatesLink } from './AffiliatesLink';

interface AffiliateStoreProps {
  variant: 'footer' | 'header' | 'subitem';
}

export const AffiliateStore = ({ variant }: AffiliateStoreProps) => (
  <AffiliatesLink variant={variant} path="/affiliate-store/" category={'Affiliate store'}>
    <I18n k="affiliates_signup_perseus.affiliates.affiliate_store" />
  </AffiliatesLink>
);
